import { render } from "./TopicTable.vue?vue&type=template&id=059bf5b4&scoped=true"
import script from "./TopicTable.vue?vue&type=script&lang=js"
export * from "./TopicTable.vue?vue&type=script&lang=js"

import "./TopicTable.vue?vue&type=style&index=0&id=059bf5b4&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059bf5b4"]])

export default __exports__